import PaddedSpinner from '../util/PaddedSpinner';
import { observer } from 'mobx-react';
import React from 'react';
import useStores from '../stores/UseStores';

interface ContentLoadWrapperProps {
  children: JSX.Element;
}

const ContentLoadWrapper = observer((props: ContentLoadWrapperProps): JSX.Element => {
  const { children } = props;
  const {
    translateStore: { fetched },
  } = useStores();

  if (!fetched) {
    return <PaddedSpinner />;
  }
  return children;
});

export default ContentLoadWrapper;
